import { AddCircleOutlineOutlined } from '@mui/icons-material'
import { Alert, Button } from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useEffectOnce } from 'react-use'

import services from '@/services'
import { useGetBillPackages } from '@/services/bill-packages/list'
import { useBillPackageStore } from '@/stores/bill-package'
import { DataTable } from '../../../components'
import { useHeaderAdmin } from '../../../hooks'
import ModalRegister from './modal-register'
import ModalUpdate from './modal-update'
import { TABLE_COLUMNS } from './table-columns'

const PACKAGES_QUERY_KEY = ['/bill-packages']

export default function BillPackages() {
  const queryClient = useQueryClient()
  const { setAction } = useHeaderAdmin()
  const { billPackage, setPackage } = useBillPackageStore()
  const { isLoading, error, data } = useGetBillPackages()

  const [isModalRegisterOpen, setIsModalRegisterOpen] = useState<boolean>(false)

  const toggleModalRegister = () => setIsModalRegisterOpen(!isModalRegisterOpen)

  useEffectOnce(() => {
    setAction(
      <Button onClick={toggleModalRegister}>
        <AddCircleOutlineOutlined />
        <span>Registar</span>
      </Button>,
    )
  })

  if (error) return <Alert severity="error">{(error as Error).message}</Alert>

  return (
    <>
      <ModalUpdate open={billPackage !== null} />
      <ModalRegister open={isModalRegisterOpen} onClose={toggleModalRegister} />

      <DataTable
        data={data ?? []}
        isLoading={isLoading}
        columns={TABLE_COLUMNS}
        inputProps={{ name: 'name' }}
        actions={{
          queryKey: PACKAGES_QUERY_KEY,
          async onUpdate(data) {
            setPackage(data)
          },
          async onDelete(data) {
            await services.packages.deleteById(data.id)
            await queryClient.invalidateQueries({ queryKey: PACKAGES_QUERY_KEY })
          },
        }}
      />
    </>
  )
}
